import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { CircularProgress } from 'material-ui/Progress';

import { enums } from '../../enums/';
import { assets } from '../../assets/';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing(3),
    overflowX: 'auto',
  },
  table: {
    minWidth: 650,
  },
}));

function createData(name, icon, city, percentage, price) {
  return { name, icon, city, percentage, price };
}

const rows = [
  createData(
    'Usine 1',
    assets.images.factoryMapIcon2,
    'Lille, Hauts-de-France',
    '3%',
    0
  ),
  createData(
    'Usine 2',
    assets.images.factoryMapIcon2,
    'Lyon, Auvergne-Rhône-Alpes',
    '2%',
    0
  ),
  createData(
    'MySolar',
    assets.images.solarPanelMapIcon2,
    'Gréoux-les-Bains, Occitanie',
    '20%',
    1.9
  ),
  createData(
    'Fontanelles',
    assets.images.windTurbineMapIcon2,
    'Brusque, Occitanie,',
    '10%',
    1.8
  ),
  createData(
    'Marèges',
    assets.images.damMapIcon2,
    'Liginiac, Nouvelle-Aquitaine',
    '30%',
    1.2
  ),
  createData(
    'Eget',
    assets.images.damMapIcon2,
    'Saint-Lary-Soulan, Occitanie',
    '10%',
    1.1
  ),
  createData(
    'Coindre',
    assets.images.damMapIcon2,
    'Saint-Amandin, Auvergne-Rhône-Alpes',
    '15%',
    1.1
  ),
  createData(
    'Soulom',
    assets.images.damMapIcon2,
    'Soulom, Occitanie',
    '10%',
    1
  ),
];

export default function AssetsList(props) {
  const classes = useStyles();

  let assetsArray = props.assets ? props.assets : rows;

  assetsArray = assetsArray.map(asset => {
    switch (asset.assetType) {
      case enums.AssetType.WIND_TURBINE:
        asset.icon = assets.images.windTurbineMapIcon2;
        break;
      case enums.AssetType.SOLAR_PANEL:
        asset.icon = assets.images.solarPanelMapIcon2;
        break;
      case enums.AssetType.DAM:
        asset.icon = assets.images.damMapIcon2;
        break;
      case enums.AssetType.FACTORY:
        asset.icon = assets.images.factoryMapIcon2;
        break;
      case enums.AssetType.GEOTHERMAL:
        asset.icon = assets.images.geothermalIcon;
        break;
      case enums.AssetType.SOLID_BIOMASS:
        asset.icon = assets.images.solidBiomassIcon;
        break;
      default:
        asset.icon = assets.icons.boltMapIcon2;
    }
    return asset;
  });

  return (
    <Paper className={classes.root}>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell style={{ fontFamily: 'Inter-Regular' }}>Actif</TableCell>
            <TableCell align="right" style={{ fontFamily: 'Inter-Regular' }}>
              Commune
            </TableCell>
            <TableCell align="right" style={{ fontFamily: 'Inter-Regular' }}>
              Couverture
            </TableCell>
            <TableCell align="right" style={{ fontFamily: 'Inter-Regular' }}>
              Prix GO (€/MWh)
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.loading && (
            <TableRow key="loading">
              <TableCell
                component="th"
                scope="row"
                style={{ fontFamily: 'Inter-Regular', fontSize: 12 }}
              >
                <CircularProgress
                  size={24}
                  className={classes.buttonProgress}
                />
              </TableCell>
              <TableCell
                align="right"
                style={{ fontFamily: 'Inter-Regular', fontSize: 12 }}
              />
              <TableCell
                align="right"
                style={{ fontFamily: 'Inter-Regular', fontSize: 12 }}
              />
              <TableCell
                align="right"
                style={{ fontFamily: 'Inter-Regular', fontSize: 12 }}
              />
            </TableRow>
          )}

          {!props.loading && assetsArray && assetsArray.length < 1 && (
            <TableRow key="no-selected-assets">
              <TableCell
                component="th"
                scope="row"
                style={{ fontFamily: 'Inter-Regular', fontSize: 12 }}
              >
                Aucun actif sélectionné
              </TableCell>
              <TableCell
                align="right"
                style={{ fontFamily: 'Inter-Regular', fontSize: 12 }}
              />
              <TableCell
                align="right"
                style={{ fontFamily: 'Inter-Regular', fontSize: 12 }}
              />
              <TableCell
                align="right"
                style={{ fontFamily: 'Inter-Regular', fontSize: 12 }}
              />
            </TableRow>
          )}
          {!props.loading &&
            assetsArray.map((asset, index) => (
              <TableRow key={asset.name}>
                <TableCell
                  component="th"
                  scope="row"
                  style={{ fontFamily: 'Inter-Regular', fontSize: 12 }}
                >
                  <img
                    src={asset.icon}
                    alt="asset_icon"
                    style={{
                      maxHeight: 16,
                      marginRight: 5,
                    }}
                  />
                  {asset.displayedName}
                </TableCell>
                <TableCell
                  align="right"
                  style={{ fontFamily: 'Inter-Regular', fontSize: 12 }}
                >
                  {asset.city}
                </TableCell>
                <TableCell
                  align="right"
                  style={{ fontFamily: 'Inter-Regular', fontSize: 12 }}
                >
                  {asset.percentage ? asset.percentage : rows[index].percentage}
                  %
                </TableCell>
                <TableCell
                  align="right"
                  style={{ fontFamily: 'Inter-Regular', fontSize: 12 }}
                >
                  {asset.price ? asset.price : rows[index].price}€
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </Paper>
  );
}



// WEBPACK FOOTER //
// ./src/components/commons/AssetsList.js